exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dx-icon-chevrondoubleleft,.dx-icon-chevrondoubleright{font-size:21px}", ""]);

// exports
